<template>
  <b-row class="justify-content-center my-5">
    <b-col cols="10" lg="6" class="sg-rounded-container">
      <b-row class="justify-content-center">
        <b-col cols="12" lg="8" class="p-5">
          <b-img
            :src="require('@/assets/img/customer/happy-money.png')"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h4>Thanks for Your Payment</h4>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h6>
            You've made a good choice, we have receive your payment. Hope you have a good trip with our Guiders!
          </h6>
        </b-col>
      </b-row>

      <b-row class="mt-3" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Pay_Success'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pay/Success.vue